import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function BuyerProtectionPolicy() {
  return (
    <Container>
      <div class="privacy_text">
        <div class="header-logo">
          <a class="terms-and-conditions link" href="#">
            <img src={require("../assets/images/new-logo-ex.png")} />
          </a>
          <h2>Buyer Protection Policy</h2>
        </div>
        <h6>
          <b>Effective Date</b>: 1<sup>st</sup> October 2024{" "}
        </h6>
        <h6>
          <b>Last Updated</b>: 1<sup>st</sup> October 2024{" "}
        </h6>

        <p>
          At Wedged Limited we are committed to providing a safe and trustworthy
          environment for users to buy and sell items through our
          Consumer-to-Consumer (C2C) marketplace. This Buyer Protection Policy
          explains the protections we offer to buyers and how you can seek
          assistance if an issue arises with a purchase.
        </p>
        <h4 className="mb-2 pb-0">1. Eligibility for Buyer Protection </h4>
        <p>
          To qualify for protection under this policy, buyers must meet the
          following conditions:{" "}
        </p>
        <ul>
          <li>
            The transaction must have been completed through Wedged, including
            payment via the app's approved payment methods.
          </li>

          <li>
            The issue must be reported within 48 hours of receiving the item.
          </li>

          <li>
            The item must not be as described in the listing (e.g. it is
            significantly different, damaged, counterfeit, or missing parts).
          </li>
          <li>
            The item must be eligible for Buyer Protection (certain items, such
            as services, perishable goods, or prohibited items, may not
            qualify).{" "}
          </li>
        </ul>
        <p>
          Note: Buyers who arrange payments or transactions outside of the App
          will not be eligible for Buyer Protection.{" "}
        </p>

        <h4 className="mb-2 pb-0">
          2. Situations Covered by Buyer Protection{" "}
        </h4>
        <p>
          This policy covers the following situations where the item you receive
          is significantly not as described in the listing:{" "}
        </p>
        <ul>
          <li>
            {" "}
            The item is materially different from the description or photos
            provided by the seller.
          </li>
          <li>
            {" "}
            The item is damaged or broken, but the listing did not disclose this
            condition.{" "}
          </li>
          <li>
            The item is counterfeit, fraudulent, or otherwise misrepresented.{" "}
          </li>
          <li>The item is considered lost by the delivery provider. </li>
          <li>
            The seller fails to provide all items or components as described
            (e.g., missing parts or accessories).
          </li>

          <li>You receive a completely different item. </li>
        </ul>

        <h4 className="mb-2 pb-0">
          3. Situations Not Covered by Buyer Protection{" "}
        </h4>
        <p>
          The following scenarios are not covered under our Buyer Protection
          Policy:
        </p>
        <ul>
          <li>
            You changed your mind after purchase or no longer want the item.{" "}
          </li>
          <li>
            The item was accurately described but does not meet your personal
            expectations or preferences.{" "}
          </li>
          <li>
            Minor issues such as small scratches or wear that were disclosed in
            the listing.{" "}
          </li>
          <li>
            The item is prohibited or restricted and should not have been listed
            (in such cases, we may remove the listing but are not responsible
            for the transaction).{" "}
          </li>
          <li>The buyer arranged payment outside of Wedged. </li>
        </ul>

        <h4 className="mb-2 pb-0">4. How to File a Claim </h4>
        <p>
          If you believe the item you received qualifies for Buyer Protection,
          follow these steps:{" "}
        </p>
        <ul>
          <li>
            Report the issue: Contact us through the in-app dispute resolution
            tool within 48 hours of receiving the item.{" "}
          </li>
          <li>
            Provide evidence: Submit photos, descriptions, and any supporting
            evidence that shows how the item differs from the listing. This
            information will help us evaluate the claim.{" "}
          </li>
          <li>
            Cooperate with the process: The buyer and seller will be required to
            respond to inquiries and cooperate with our dispute resolution team.{" "}
          </li>
        </ul>
        <p>
          We will review your claim and determine if it is eligible for a refund
          or another resolution based on the evidence provided.
        </p>
        <h4 className="mb-2 pb-0">5. Resolution Options </h4>
        <p>If your claim is approved, we may offer the following solutions: </p>
        <p>
          Full refund: You may be eligible for a full refund, provided that you
          return the item to the seller. The return process, including shipping
          fees, may be handled in accordance with local regulations and the
          app’s policies.{" "}
        </p>
        <p>
          Partial refund: In some cases, if the issue is minor, we may offer a
          partial refund to cover the difference between the item’s actual
          condition and what was described.{" "}
        </p>
        <p>
          Item replacement or repair: If feasible, the seller may offer to
          replace or repair the item at no additional cost to the buyer.{" "}
        </p>
        <h4 className="mb-2 pb-0">6. Refund Process</h4>
        <p>
          If a refund is issued, the funds will be credited to the original
          payment method used in the transaction. Refunds typically take 5
          business days to process after approval, depending on the payment
          provider.{" "}
        </p>
        <h4 className="mb-2 pb-0">7. Seller Responsibilities </h4>
        <p>Sellers on Wedged are expected to: </p>
        <ul>
          <li>Accurately describe their items in listings. </li>
          <li>
            Provide truthful information about the condition, authenticity, and
            any defects.{" "}
          </li>
          <li>
            Respond to buyer inquiries and cooperate in resolving disputes.{" "}
          </li>
        </ul>
        <p>
          Failure to comply with these obligations may result in penalties,
          including removal of the listing, suspension of the seller’s account,
          or a ban from the platform.{" "}
        </p>
        <h4 className="mb-2 pb-0">8. Limitations of Liability </h4>
        <p>
          While Wedged aims to facilitate smooth transactions and protect
          buyers, we cannot guarantee the quality or authenticity of items
          listed on the platform. Our Buyer Protection Policy is designed to
          help resolve disputes when they arise, but buyers should always review
          listings carefully and communicate with sellers before making a
          purchase.{" "}
        </p>
        <h4 className="mb-2 pb-0">9. Changes to This Policy </h4>
        <p>
          We may update this Buyer Protection Policy from time to time. Any
          changes will be communicated via updates to the app or on our website,
          and the "Effective Date" at the top of the policy will reflect when
          those changes take effect. Your continued use of the app after such
          changes constitutes your acceptance of the updated policy.{" "}
        </p>
        <h4 className="mb-2 pb-0">10. Contact Us </h4>
        <p>
          If you have any questions about this Buyer Protection Policy or need
          assistance with a claim, please contact us at:{" "}
        </p>
        <ul>
          <li>
            Email: {""}
            <Link to="mailto:team@wedged.golf">team@wedged.golf</Link>
          </li>
          <li> In-App Message: TeamWedged</li>
        </ul>
      </div>
    </Container>
  );
}
